import { withMetadata } from '../metadata'
import { getCountryCallingCode as _getCountryCallingCode } from '../../core/index'

export function getCountryCallingCode() {
	return withMetadata(_getCountryCallingCode, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js
// module id = 634
// module chunks = 0